import { render, staticRenderFns } from "./StaticMenu.vue?vue&type=template&id=2176725e&scoped=true&"
import script from "./StaticMenu.vue?vue&type=script&lang=js&"
export * from "./StaticMenu.vue?vue&type=script&lang=js&"
import style0 from "./StaticMenu.vue?vue&type=style&index=0&id=2176725e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2176725e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbar})
